import React from 'react';
import styles from './MustChooseLeague.module.css';
import srcWhistle from '../../graphics/images/whistle.png';
import HeaderTopic from '../HeaderTopic';
import PrimaryButton from '../PrimaryButton';
import { useHistory } from 'react-router-dom';

function CheckStates({ league, children }) {
  const history = useHistory();
  return (<div className={styles.wrapper}>
    <HeaderTopic topic={ 'בחירת ליגה'} />
    <div className={styles.bgVisual}></div>
    <div className={styles.errorContainer}>
      <h2 className={styles.errorHeader}>יש לבחור ליגה לפני צפייה בפרופיל</h2>
      <img src={srcWhistle} alt="שופר" />
      <PrimaryButton onClick={()=>history.push('/leagues')}  size={'large'} text={'   חזרה' +
        ' לבחירת ליגה'}>

      </PrimaryButton>

    </div>
  </div>);


}

export default CheckStates;
